import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './icons/index';
import './styles/index.scss';
import './utils/auth';
import './utils/permission';
// import vant from '@/components/Vant'
import vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from "vant";
// eslint-disable-next-line
const app = createApp(App);
app.directive('debounce', {
    mounted(el, binding, vnode) {
        let timer = {};
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                binding.value();
            }, 250);
        });
    }
});
app.use(store).use(router).use(vant).use(Lazyload).mount('#app');
